import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { format } from 'date-fns';

@Component({
  selector: 'app-scan-success',
  templateUrl: './scan-success.component.html',
  styleUrls: ['./scan-success.component.scss'],
})
export class ScanSuccessComponent implements OnInit {

  dateNow;
  routeType;
  status;
  message;
  data;

  constructor(
    public modalController: ModalController
  ) { }

  ngOnInit() {
    // this.dateNow = format(new Date(), 'lll');
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true
    });
  }
}
